import { LoggerService } from "@modules/common/logger/loggerService"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { type ProgramBundleApiGateway } from "@modules/programBundle/api/programBundleApiGateway"
import {
  type ProgramBundleDraftDto,
  type ProgramBundleDto,
  ProgramBundleDtoSchema,
  type ProgramBundleItemDto,
  ProgramBundleItemDtoSchema,
  ProgramBundleType,
} from "@modules/programBundle/api/programBundleDto"

export class ProgramBundleApi implements ProgramBundleApiGateway {
  private baseUrl = "/program-bundles"

  constructor(private api: ApiClient) {}

  async getProgramBundle(programBundleId: string): Promise<ProgramBundleDto> {
    const result = await this.api.get<ProgramBundleDto>(`${this.baseUrl}/${programBundleId}`)

    return LoggerService.parseApiDto(ProgramBundleDtoSchema, result.data)
  }

  // Use null for filter to get all program bundles
  async getProgramBundles(filter: ProgramBundleType | null, onlyWithPrice: boolean): Promise<ProgramBundleDto[]> {
    const resultDto = await this.api.get<ProgramBundleDto[]>(`${this.baseUrl}`, {
      params: { filter, onlyWithPrice },
    })
    return resultDto.data.map((programBundleDto) => LoggerService.parseApiDto(ProgramBundleDtoSchema, programBundleDto))
  }

  async getProgramBundlesSubscribed(): Promise<ProgramBundleItemDto[]> {
    const resultDto = await this.api.get<ProgramBundleItemDto[]>(`${this.baseUrl}/subscribed`)
    return resultDto.data.map((programBundle) => LoggerService.parseApiDto(ProgramBundleItemDtoSchema, programBundle))
  }

  async createProgramBundle(programBundleDraft: ProgramBundleDraftDto): Promise<ProgramBundleDto> {
    const response = await this.api.post<void>(`${this.baseUrl}`, programBundleDraft)
    return LoggerService.parseApiDto(ProgramBundleDtoSchema, response.data)
  }

  async updateProgramBundle(programBundleId: string, programBundleDraft: ProgramBundleDraftDto): Promise<void> {
    await this.api.put<void>(`${this.baseUrl}/${programBundleId}`, programBundleDraft)
  }

  async deleteProgramBundle(programBundleId: string): Promise<void> {
    await this.api.delete<void>(`${this.baseUrl}/${programBundleId}`)
  }
}
